import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Atlante } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<Atlante>()

export function TableAtlanti({
  atlanti,
  setFilters,
  filters,
  count,
  fullCount,
  actionLink,
}: {
  atlanti: Atlante[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
  actionLink?: (v?: Atlante) => void
}) {
  const numPages = useMemo(() => {
    if (!atlanti) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [atlanti, count])

  return (
    <Table
      data={atlanti}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="titolo_completo"
        sortable
        width="400px"
        render={(item) =>
          actionLink ? (
            <LinkMagik className="text-dark" onClick={() => actionLink(item)} style={{ cursor: "pointer" }}>
              {item.nome}
            </LinkMagik>
          ) : (
            <Link to={`/atlanti/atlanti/${item.id}`}>
              <LinkMagik className="text-dark">{item.nome}</LinkMagik>
            </Link>
          )
        }
        stickyLeft
      />

      <Table.Column
        title="Immagine copertina"
        name="immagine_copertina"
        sortable
        width="minmax(max-content, 1fr)"
        render={(item) => 
          item.immagine_copertina ? (
            <img
              src={item.immagine_copertina}
              alt={item.nome}
              style={{ height: 100 }}
            />
          ) : (
            "N/A"
          )
        }
      />
      
      <Table.Column
        title="Bozza"
        name="bozza"
        sortable
        width="minmax(max-content, 1fr)"
        render={(item) => (item.bozza ? "Si" : "No")}
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} atlanti
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
